import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { computed, PropType } from "vue";
import { TaskParameterTypeEnum } from "./enums";
import { TaskParameterModel } from "./models";
import {
  DifficultyParameter,
  PriorityParameter,
  StatusParameter,
  TagParameter,
  TypeParameter,
} from "./components";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-parameter',
  props: {
  /**Данные о настройке */
  data: { type: Object as PropType<TaskParameterModel>, default: () => new TaskParameterModel() },
  /**Тип настройки */
  type: { type: Number as PropType<TaskParameterTypeEnum> },
  /**Демонстрационный тег */
  preview: { type: Boolean, default: false },
  /**Убрать кнопку удаления */
  hideRemove: { type: Boolean, default: false },
  /**Редактирование */
  isEditing: { type: Boolean, default: false },
  /**Укороченная информация параметра */
  shortInfoParameter: { type: Boolean, default: false },
},
  emits: ["remove", "upsert"],
  setup(__props, { emit }) {

const props = __props;


/**События */


/**Компонент для отображения параметра */
const parameterComponent = computed(() => {
  switch (props.type) {
    case TaskParameterTypeEnum.Status:
      return StatusParameter;
    case TaskParameterTypeEnum.Priority:
      return PriorityParameter;
    case TaskParameterTypeEnum.Tag:
      return TagParameter;
    case TaskParameterTypeEnum.Difficulty:
      return DifficultyParameter;
    case TaskParameterTypeEnum.Type:
      return TypeParameter;
  }
});

/**Класс бейджа */
const parameterClass = computed(() => {
  const classes = [];
  switch (props.type) {
    case TaskParameterTypeEnum.Status:
      classes.push("parameter-status");
      break;
    case TaskParameterTypeEnum.Priority:
      classes.push("parameter-priority");
      break;
    case TaskParameterTypeEnum.Tag:
      classes.push("parameter-tag");
      break;
    case TaskParameterTypeEnum.Difficulty:
      classes.push("parameter-difficulty");
      break;
    case TaskParameterTypeEnum.Type:
      classes.push("parameter-type");
      break;
  }

  return classes;
});
/**Имя типа настройки */
const typeText = computed(() => {
  switch (props.type) {
    case TaskParameterTypeEnum.Status:
      return "статуса";
    case TaskParameterTypeEnum.Priority:
      return "приоритета";
    case TaskParameterTypeEnum.Tag:
      return "тега";
    case TaskParameterTypeEnum.Difficulty:
      return "сложности";
    case TaskParameterTypeEnum.Type:
      return "типа";
  }
});

/**Событие удаления тега */
const remove = () => emit("remove", props.data.Name);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["task-parameter-wrapper", parameterClass.value])
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(parameterComponent.value), {
      isEditing: __props.isEditing,
      data: props.data,
      type: props.type,
      shortInfoParameter: __props.shortInfoParameter,
      "hide-remove": __props.hideRemove || __props.preview,
      preview: __props.preview,
      onRemove: remove
    }, null, 40, ["isEditing", "data", "type", "shortInfoParameter", "hide-remove", "preview"]))
  ], 2))
}
}

})